import * as tslib_1 from "tslib";
import Axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import unCompleteBm from "../../../src/views/workflow-center/workbenchInfo/workbenchComponents/unCompleteBm.vue";
let HomePage = class HomePage extends Vue {
    constructor() {
        //
        //   handleClickRouterPush(){
        //       this.$router.push('/application/expat/application-list/expat_Information?parentId=8a7485c5865d839301865d967a690a64&code=expat_Information&openMode&pcUrl&queryCode=')
        //   }
        //   handleClickCreateExpat(){
        //       window.open('/form/createExpatInformation')
        //   }
        super(...arguments);
        this.contactList = {};
    }
    //Contact_infomation数据
    created() {
        this.getContactList();
    }
    //获取联系信息
    getContactList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = window.location.href;
            let index = url.indexOf("/");
            // let c = url.substring(index + 2, url.length);
            let urlArr = url.substring(index + 2, url.length).split("/");
            let code = urlArr[2];
            let parmas = {
                filters: [
                    {
                        propertyCode: "appsCode",
                        propertyType: 14,
                        propertyValue: code,
                        propertyValueName: "",
                    },
                ],
                mobile: false,
                page: 0,
                queryCode: "contactList",
                schemaCode: "contactList",
                size: 999,
            };
            let res = yield Axios.post("/api/runtime/query/list", parmas);
            if (res.errcode === 0) {
                res.data.content.forEach((item) => {
                    if (code === item.data.appsCode) {
                        this.contactList = item.data;
                    }
                });
            }
        });
    }
};
HomePage = tslib_1.__decorate([
    Component({
        name: "HomePage",
        components: {
            unCompleteBm
            //
        },
    })
], HomePage);
export default HomePage;
